import log from 'loglevel';
import dashFetch from './dashFetch';
import { NotificationManager } from 'react-notifications';

export default async (email, alwaysEmailReceipt, checkId, debug) => {
	return new Promise(async (resolve, reject) => {
		try {
			if (debug) log.info('***** Email receipt API ****');

			const url = `${global.dashServerUrl}/api/v1/account/emailReceipt`;
			const body = {
				email,
				alwaysEmailReceipt,
				checkId,
			};
			if (debug) log.info(JSON.stringify(body));
			dashFetch(url, body, debug)
				.then(({ res, json }) => {
					if (json.success) {
						resolve(true)
					} else {
						NotificationManager.warning('', json.errors, 3000)
					}
				})
				.catch((err) => {
					reject(err)
				});
		} catch (e) {
			log.info(e)
		}
	});
};
